parseHexOctet